<div id="app" class="h-100 app" [ngClass]="settings.theme" [dir]="'ltr'">
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
</div>